import { Component, NgModule, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectControlItemService,
  ProjectService, TenantService,
  UserService,
} from '../../_services/index';
import { ProjectControlItem, User } from '../../_models/index';
import { LoginHelper, Role } from '../../helpers';
import { saveAs as importedSaveAs } from "file-saver";
import { Evidence } from 'src/app/_models/evidence';


@Component({
    standalone: false,
  selector: "evidence-archive",
  templateUrl: 'evidenceArchive.component.html',
  styleUrls: ['evidenceArchive.component.css'],
})
export class EvidenceArchiveComponent implements OnInit {
  model: any = {};
  userMap = {};
  loading = false;
  currentUser: User;
  isRealUser = false;
  selectedProject: number;
  cols: any[] = [
    // { field: 'controlId', header: 'Control ID' },
    // { field: 'name', header: 'Name' },
    { field: 'complianceAreaControlId', header: 'Control', tooltip: 'Control Name' },
    { field: 'ps', header: 'P', tooltip: 'Prior' },
    { field: 'cs', header: 'C', tooltip: 'Current' },
  ];
  controls: any[];
  categories: any[];
  years: any[] = [
    { label: '2021', value: 2021 },
    { label: '2022', value: 2022 },
    { label: '2023', value: 2023 },
    { label: '2024', value: 2024 },
    { label: '2025', value: 2025 },
  ];
  expandedCategories = {};
  expandedSmallItem = {};
  rowGroupMetadata = {};
  remainingControls: any[] = [];
  selectedYear: number;
  projects: any[];

  constructor(
    private route : ActivatedRoute,
    public router: Router,
    public userService: UserService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public projectDataService: ProjectService,
    public http: HttpClient,
    public fileBlobService: FileBlobService,
    // public evidenceArchiveService: EvidenceArchiveService,
  ) { }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isRealUser = (this.currentUser.role & (Role.Survey | Role.Training | Role.Vendor)) === 0;

    // Get projectID from URL if available
    this.route.paramMap.subscribe(params => {
      const projectIDparam = params.get('projectId');
      if (projectIDparam) {
        this.selectedProject = +projectIDparam;
      }

      this.loadProjects();
    });

    this.userService.getAllShort().subscribe(users => {
      //this.users = users;
      users.forEach(u => this.userMap[u.userId] = u);
    });
  }

  loadProjects() {
    this.projectService.getAllShort().subscribe((projects: any[]) => {
      this.projects = projects;
      if (this.projects.length) {
        // If theres no projectId requested, default to the first project
        if (!this.selectedProject) {
          this.selectedProject = this.projects[0].projectId;
        }
        this.onProjectChanged({ value: this.selectedProject });
      }
    });
  }

  onProjectChanged(event) {
    this.selectedProject = event.value;
    this.loadControls(this.selectedProject);
  }

  // TODO fix to be similar to projectNew
  public downloadEvidence(control: any, fileName: string, isPath: boolean = false) {
    // Find the project object by selectedProject
    const project = this.projects?.find(p => p.projectId === this.selectedProject);
    const projectName = project ? project.name : this.selectedProject;

    let assignedClient = control.assignedClientId ? this.userMap[control.assignedClientId] : null;
    let vendorPath = '';
    if (assignedClient && assignedClient.role === Role.Vendor) {
      vendorPath = "/Vendors/" + encodeURIComponent(assignedClient.emailAddress.replace('@', '_'));
    }

    const shortFolderName = control.shortFolderName || control.folderName || control.complianceAreaControlId || 'unknown';

    const folderPath = "Projects/" + projectName + vendorPath + '/Evidence/' + shortFolderName;

    this.fileBlobService
      .downloadFile(
        isPath ? fileName.replace(/^.*[\\\/]/, '') : fileName,
        isPath ? fileName.replace(/[^\\/]*$/, '') : folderPath
      )
      .subscribe(
        (blob) => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        (error) => {
          const errorMessage = 'An error occurred while downloading evidence.';
          this.alertService.error(errorMessage);
        }
      );
  }

  loadControls(projectId: number) {
    this.http.get<any[]>(`/api/projectControlItems/groupedByCategory/${projectId}`).subscribe(
      (data: any[]) => {
        if (data && Array.isArray(data)) {
          // Process controls for the left side
          const allControls = data.flatMap(category => category.controls);
          this.remainingControls = this.filterParentControls(allControls);

          console.log('Filtered Parent Controls:', this.remainingControls);

          // Populate rowGroupMetadata for hierarchical display
          this.updateRowGroupMetaData(this.remainingControls);

          // Process categories for the right side
          this.categories = data.map(category => ({
            category: category.category,
            controls: category.controls.map(control => ({
              ...control,
              evidence: control.evidence || [], // Ensure evidence is an array
              filteredEvidence: control.evidence || [], // Initialize filtered evidence
              selectedYear: null // Initialize selected year
            }))
          }));
          console.log('Fetched controls for project:', projectId);
          console.log('Data: ', data)
          console.log('Categories: ', this.categories)
          console.log('Controls: ', this.remainingControls)

        } else {
          console.error('Unexpected API response format:', data);
          this.remainingControls = [];
          this.categories = [];
        }
      },
      error => {
        console.error('Error fetching controls:', error);
        this.remainingControls = [];
      }
    );
  }

  groupControlsByCategory(controls: any[]): any[] {
    const grouped = {};

    controls.forEach(control => {
      const categoryName = control.category || 'Uncategorized';
      if (!grouped[categoryName]) {
        grouped[categoryName] = { category: categoryName, controls: [] };
      }
      grouped[categoryName].controls.push(control);
    });

    return Object.values(grouped);
  }

  updateRowGroupMetaData(data: any[]) {
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        const rowData = data[i];
        const category = rowData.category || 'Uncategorized';
        if (i === 0 || category !== data[i - 1].category) {
          this.rowGroupMetadata[category] = { index: i, size: 1 };
        } else {
          this.rowGroupMetadata[category].size++;
        }
      }
    }
  }

  // Helper function to filter out sub-items
  filterParentControls(controls: any[]): any[] {
    if (!controls || !Array.isArray(controls)) {
      console.error('Invalid controls data:', controls);
      return [];
    }

    // Collect all sub-control IDs
    const subItemIds = new Set(
      controls.flatMap(control => (control.subItems || []).map(subItem => subItem.controlItemId))
    );

    // Return only controls that are not listed as sub-items
    return controls.filter(control => control && !subItemIds.has(control.controlItemId));
  }

  getFilteredEvidence(control: any): any[] {
    if (control.selectedYear) {
      return control.evidence.filter(evidence => {
        const evidenceYear = new Date(evidence.date).getFullYear();
        return evidenceYear === control.selectedYear;
      });
    }
    return control.evidence; // Default: show all evidence
  }

  saveEvidenceNotes(evidence: Evidence) {
    this.fileBlobService.updateEvidence(evidence).subscribe(
      (res: any) => {
        this.alertService.success('Evidence notes updated.');
      },
      (error) => {
        this.alertService.error('Failed to update evidence notes.');
      }
    );
  }
}

